import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpShop'

export const productSupplierList = (params = '') => Http.get(`/product-suppliers${serialize(params)}`)
export const productSupplierCreate = data => Http.post('/product-suppliers', data)
export const productSupplierUpdate = (id, data) => Http.put(`/product-suppliers/${id}`, data)
export const productSupplierDestroy = id => Http.delete(`/product-suppliers/${id}`)
